export default __webpack_public_path__ + "static/media/Superchat.b9feb9f9.png";